function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          height: 2px;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          width: 2px;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background: ", ";\n\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { Divider } from "@diana-ui/divider";
export default styled(Divider).attrs(props => ({
  orientation: props.orientation
}))((_ref) => {
  var {
    orientation,
    theme
  } = _ref;
  return css(_templateObject(), theme.colors.grey.grey25, orientation === "vertical" ? css(_templateObject2()) : css(_templateObject3()));
});